module.exports = __webpack_public_path__ + "static/media/services.ca9be0d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services.png
// module id = 122
// module chunks = 0